module.exports = __webpack_public_path__ + "static/media/back9.aea54ce1.jpg";